/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GanttVisualizationProfileDto } from '../models/GanttVisualizationProfileDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GanttVisualizationProfileControllerService {
    /**
     * @param uuid
     * @returns GanttVisualizationProfileDto OK
     * @throws ApiError
     */
    public static findByUuid(
        uuid: string,
    ): CancelablePromise<GanttVisualizationProfileDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/gantt-profiles/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns GanttVisualizationProfileDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: GanttVisualizationProfileDto,
    ): CancelablePromise<GanttVisualizationProfileDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/gantt-profiles/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/gantt-profiles/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @returns GanttVisualizationProfileDto OK
     * @throws ApiError
     */
    public static setDefaultProfile(
        uuid: string,
    ): CancelablePromise<GanttVisualizationProfileDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/gantt-profiles/{uuid}/set-default',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns GanttVisualizationProfileDto OK
     * @throws ApiError
     */
    public static findAll(): CancelablePromise<Array<GanttVisualizationProfileDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/gantt-profiles',
        });
    }
    /**
     * @param requestBody
     * @returns GanttVisualizationProfileDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: GanttVisualizationProfileDto,
    ): CancelablePromise<GanttVisualizationProfileDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/gantt-profiles',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns GanttVisualizationProfileDto OK
     * @throws ApiError
     */
    public static duplicateProfile(
        uuid: string,
    ): CancelablePromise<GanttVisualizationProfileDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/gantt-profiles/{uuid}/duplicate',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns GanttVisualizationProfileDto OK
     * @throws ApiError
     */
    public static getDefaultProfile(): CancelablePromise<GanttVisualizationProfileDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/gantt-profiles/default',
        });
    }
}
